<template>
  <v-data-table
    :items="getCustomUnits"
    :search="search"
    :mobile-breakpoint="0"
    :headers="headers"
    hide-default-header
    hide-default-footer
    :items-per-page="$vuetify.breakpoint.xsOnly ? 8 : 10"
    @page-count="pageCount = $event"
    :page.sync="page"
  >
    <template v-slot:item.actions="{ item }">
      <v-row align="center" justify="end" no-gutters>
        <CustomUnitEditor
          :id="item.id"
          @update="$emit('update')"
        ></CustomUnitEditor>
        <v-btn
          :small="!$vuetify.breakpoint.xsOnly"
          icon
          @click="deleteUnit(item)"
        >
          <v-icon :small="!$vuetify.breakpoint.xsOnly">fa-trash</v-icon>
        </v-btn>
      </v-row>
    </template>
    <template v-slot:item.name="{ item }">
      <span class="font-weight-bold">{{ item.name }}</span>
    </template>
    <template v-slot:top>
      <v-row align="center" justify="end" dense>
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            filled
            hide-details
            single-line
            clearable
            prepend-inner-icon="fa-search"
            v-model="search"
            class="no-before"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <template v-slot:footer>
      <v-pagination
        color="accent"
        v-model="page"
        :length="pageCount"
        :total-visible="5"
      ></v-pagination>
    </template>
  </v-data-table>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
import CustomUnitEditor from "./CustomUnitEditor";
export default {
  name: "CustomUnitGrid",
  components: {
    CustomUnitEditor
  },
  computed: {
    ...mapGetters(["getCustomUnits"])
  },
  data() {
    return {
      search: "",
      page: 1,
      pageCount: 0,
      headers: [
        { value: "name", text: "" },
        { value: "actions", text: "" }
      ]
    };
  },
  methods: {
    async deleteUnit(item) {
      const allow = await this.$dialog.confirm({
        text: "Voulez-vous vraiment supprimer cette unité?",
        title: ""
      });
      if (allow) {
        await api.deleteCustomUnit(item.id);
        this.$emit("update");
      }
    }
  }
};
</script>

<style></style>
